import * as z from 'zod';

const mockUserSchema = z.object({
  userId: z.number(),
  name: z.string(),
  dailyHours: z.number(),
});

export type MockUser = z.infer<typeof mockUserSchema>;

export const mockUserListSchema = z.array(mockUserSchema);

export type MockUsers = z.infer<typeof mockUserListSchema>;
